import { Alert } from 'react-native'

// Avviso "stai uscendo senza salvare" della pagina Pick.
// Lo stato descrive se la selezione attuale e' DIVERSA dalla pick salvata (la calcola InserimentoPick confrontando gli id, non
// con un flag impostato a mano), e si legge solo nel momento in cui si lascia la pagina (cambio tab, tasto indietro di Android).
//   dirty : selezione diversa da quella salvata
//   ack   : l'utente ha gia' scelto "Esci senza salvare" per questa selezione: non lo chiediamo di nuovo finche' non la cambia
export const pickGuard = { dirty: false, ack: false }

export const shouldWarn = () => pickGuard.dirty && !pickGuard.ack

export function confirmLeave(t, onLeave) {
  Alert.alert(
    t('pick.draft_unsaved_title'),
    t('pick.draft_unsaved_body'),
    [
      { text: t('pick.draft_exit'), style: 'destructive', onPress: () => { pickGuard.ack = true; onLeave() } },
      { text: t('pick.draft_confirm_now'), style: 'cancel' },
    ],
    { cancelable: true }
  )
}
